import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { LayoutModel } from '../../models/layout.model';
import { RootState } from '..';
import { FilterParent } from '../../models/filter.model';

// identifier
export const LAYOUT_SLICE_ID = 'layout';

// default state
const initialState: LayoutModel = {
  isNavigationOpen: false,
  projectSelectorVisible: true,
  filterParent: FilterParent.SURVEY,
  ignoreQuestionForFilters: false,
  widgetsHavePptExports: false,
  pageTitle: '',
  pageName: '',
};

// slice
const layoutSlice = createSlice({
  name: LAYOUT_SLICE_ID,
  initialState,
  reducers: {
    toggleSidebar: (state: LayoutModel, action: PayloadAction<boolean>): void => {
      state.isNavigationOpen = action.payload;
    },
    showProjectSelector: (state: LayoutModel): void => {
      state.projectSelectorVisible = true;
    },
    hideProjectSelector: (state: LayoutModel): void => {
      state.projectSelectorVisible = true;
    },
    resetFilterParent: (state: LayoutModel): void => {
      state.filterParent = FilterParent.SURVEY;
    },
    setWidgetsHavePptExports: (state: LayoutModel, action: PayloadAction<boolean>): void => {
      state.widgetsHavePptExports = action.payload;
    },
    setPageTitle: (state: LayoutModel, action: PayloadAction<string>): void => {
      state.pageTitle = action.payload;
    },
    setPageName: (state: LayoutModel, action: PayloadAction<string>): void => {
      state.pageName = action.payload;
    },
  },
});

// actions
export const {
  toggleSidebar,
  showProjectSelector,
  hideProjectSelector,
  setWidgetsHavePptExports,
  setPageTitle,
  setPageName,
} = layoutSlice.actions;

// selector

export const selectSidebarOpen = (state: RootState) => state.layout.isNavigationOpen;

export const selectProjectSelectorVisible = (state: RootState) =>
  state.layout.projectSelectorVisible;

export const selectWidgetsHavePptExports = (state: RootState) => state.layout.widgetsHavePptExports;

export const selectPageTitle = (state: RootState) => state.layout.pageTitle;
export const selectPageName = (state: RootState) => state.layout.pageName;

// reducer
export default layoutSlice;
